import React from "react"
import LocalizedTextBlock from "components/Common/LocalizedTextBlock"

// A competition's prizes, a text block (ADR 0013): four places, each a title and its prize, written once in their original language;
// the API translates them. Each field names its text by its path in the block's content, `{ items: [{ title, prize }] }`.
const PLACES = ["1st", "2nd", "3rd", "4th"]
const PRIZE_FIELDS = PLACES.flatMap((place, index) => [[`items.${index}.title`, `${place} prize · Title`], [`items.${index}.prize`, `${place} prize · Description`]])
// The four places an editor holds and saves, empty ones included, from a content's prizes; the block edits them in place.
const fourPlaces = items => PLACES.map((_, index) => ({ title: items?.[index]?.title ?? "", prize: items?.[index]?.prize ?? "" }))

// What the editor holds and saves of the prizes: their original in its language, in its four places; never the translations. A
// competition starts in the language its block reads in, which for a new one is the event's country's.
export const initialEditorPrizes = block => {
  const language = block?.originalLanguage || "ro"
  return { originalLanguage: language, [language]: fourPlaces(block?.variants?.[language]?.content?.items) }
}
const prizesOriginal = prizes => ({ language: prizes.originalLanguage, content: { items: prizes[prizes.originalLanguage] } })

// `commands`, `drafts`, `onDrafts` and `error` are the block's (LocalizedTextBlock): the author's commands on a translation that waits
// for them, the translations written by hand, and why the save is held back.
export default function CompetitionEditorPrizes({ form, block, commands, drafts, onDrafts, error }) {
  const prizes = form.values.prizes
  return <LocalizedTextBlock id="competition-prizes" title="Prizes" className="card" fields={PRIZE_FIELDS} block={block} original={prizesOriginal(prizes)}
    onLanguage={language => form.setFieldValue("prizes", { originalLanguage: language, [language]: prizes[prizes.originalLanguage] })}
    onContent={content => form.setFieldValue("prizes", { originalLanguage: prizes.originalLanguage, [prizes.originalLanguage]: content.items })}
    commands={commands} drafts={drafts} onDrafts={onDrafts} error={error} />
}
